import { createFileRoute, Outlet } from '@tanstack/react-router'

function TamReportLayout() {
  return <div className="px-4 py-4 lg:px-6 md:py-6"><Outlet /></div>
}

export const Route = createFileRoute('/_authed/_user/tam-report')({
  component: TamReportLayout,
})
